(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
if (!customElements.get('cart-note')) {
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
if (!customElements.get('cart-note')) {
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  customElements.define('cart-note', CartNote);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-modal"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )

      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )

      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["obc-product-v2"] && !Shopify.designMode) return;
  try {
    
(() => {
  const namespace = 'OBCProductV2';
  if (window[namespace]) { window[namespace].initAll(); return; }
  const instances = new Map();
  const init = root => {
    if (instances.has(root)) return;
    const controller = new AbortController();
    const on = (target, type, handler) => target?.addEventListener(type, handler, { signal: controller.signal });
    const main = root.querySelector('.obcv2__hero img');
    const dimToggle = root.querySelector('[data-dim-toggle]');
    const dimensions = root.querySelector('[data-dimensions]');
    const dimLabel = root.querySelector('[data-dim-label]');
    const setDimensions = visible => {
      if (!dimToggle || !dimensions) return;
      dimToggle.setAttribute('aria-pressed', String(visible));
      dimensions.hidden = !visible;
      if (dimLabel) dimLabel.textContent = visible ? 'Dimensions on' : 'Show dimensions';
    };
    if (dimToggle && dimensions) {
      setDimensions(dimToggle.getAttribute('aria-pressed') === 'true');
      on(dimToggle, 'click', () => setDimensions(dimToggle.getAttribute('aria-pressed') !== 'true'));
    }
    const trialProcess = root.querySelector('[data-trial-process]');
    const mobileTrial = window.matchMedia('(max-width: 520px)');
    let trialProcessTouched = false;
    const fitTrialProcess = () => {
      if (trialProcess && !trialProcessTouched) trialProcess.open = !mobileTrial.matches;
    };
    if (trialProcess) {
      fitTrialProcess();
      on(trialProcess.querySelector('summary'), 'click', () => { trialProcessTouched = true; });
      on(mobileTrial, 'change', fitTrialProcess);
    }
    const opener = root.querySelector('[data-lb-open]');
    const thumbs = [...root.querySelectorAll('.obcv2__thumb')];
    const lb = root.querySelector('[data-lightbox]');
    const lbImg = lb?.querySelector('img');
    const lbCount = lb?.querySelector('.obcv2__lbcount');
    const images = thumbs.length ? thumbs.map(t => ({src:t.dataset.large, alt:t.dataset.alt})) : main ? [{src:opener.href, alt:main.alt}] : [];
    let index = Math.max(0, thumbs.findIndex(t => t.classList.contains('is-on')));
    let returnFocus = null;
    let savedOverflow = '';
    let scrollLocked = false;
    const select = (i) => {
      if (!main || !thumbs[i]) return;
      index = i;
      thumbs.forEach((t, j) => {
        t.classList.toggle('is-on', j === i);
        if (j === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      main.srcset = thumbs[i].dataset.srcset;
      main.src = thumbs[i].dataset.src;
      main.alt = thumbs[i].dataset.alt;
      opener.href = thumbs[i].dataset.large;
    };
    thumbs.forEach((thumb, i) => {
      on(thumb, 'click', event => { event.preventDefault(); select(i); });
      on(thumb, 'keydown', event => {
        if (event.key === ' ') { event.preventDefault(); select(i); }
      });
    });
    const show = i => {
      if (!images.length || !lbImg) return;
      index = (i + images.length) % images.length;
      lbImg.removeAttribute('srcset');
      lbImg.src = images[index].src;
      lbImg.alt = images[index].alt;
      lbCount.textContent = `${index + 1} / ${images.length}`;
    };
    const restore = () => {
      if (!scrollLocked) return;
      document.body.style.overflow = savedOverflow;
      scrollLocked = false;
      if (thumbs.length) select(index);
      if (returnFocus?.isConnected) returnFocus.focus({preventScroll:true});
    };
    const open = event => {
      if (!lb?.showModal || !images.length) return;
      event.preventDefault();
      returnFocus = document.activeElement;
      show(index);
      savedOverflow = document.body.style.overflow;
      lb.showModal();
      document.body.style.overflow = 'hidden';
      scrollLocked = true;
      lb.querySelector('[data-lb-close]').focus();
    };
    on(opener, 'click', open);
    on(opener, 'keydown', event => { if (event.key === ' ') open(event); });
    on(lb?.querySelector('[data-lb-close]'), 'click', () => lb.close());
    on(lb, 'close', restore);
    on(lb, 'click', event => { if (event.target === lb) lb.close(); });
    on(lb?.querySelector('[data-lb-prev]'), 'click', () => show(index - 1));
    on(lb?.querySelector('[data-lb-next]'), 'click', () => show(index + 1));
    on(lb, 'keydown', event => {
      if (event.key === 'Tab') {
        const buttons = [...lb.querySelectorAll('button')].filter(button => !button.hidden && !button.disabled);
        const first = buttons[0], last = buttons[buttons.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      }
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault(); show(index + (event.key === 'ArrowLeft' ? -1 : 1));
      }
    });
    lb?.querySelectorAll('[data-lb-prev],[data-lb-next]').forEach(b => { b.hidden = images.length < 2; });
    const themeButton = root.querySelector('[data-theme-toggle]');
    const autoButton = root.querySelector('[data-theme-auto]');
    const getPreference = () => { try { return localStorage.getItem('obc-theme'); } catch { return null; } };
    const paint = () => {
      const evening = document.documentElement.classList.contains('obc-evening');
      themeButton.textContent = evening ? 'Evening' : 'Day';
      themeButton.setAttribute('aria-pressed', String(evening));
      autoButton.hidden = !getPreference();
    };
    const autoTheme = () => {
      const hour = new Date().getHours();
      document.documentElement.classList.toggle('obc-evening', hour >= 18 || hour < 7);
    };
    if (!window.OBCDN) {
      const preference = getPreference();
      if (preference) document.documentElement.classList.toggle('obc-evening', preference === 'evening'); else autoTheme();
    }
    root.querySelector('.obcv2__theme').hidden = false;
    on(themeButton, 'click', () => {
      if (window.OBCDN?.toggle) window.OBCDN.toggle();
      else {
        const evening = !document.documentElement.classList.contains('obc-evening');
        document.documentElement.classList.toggle('obc-evening', evening);
        try { localStorage.setItem('obc-theme', evening ? 'evening' : 'day'); } catch {}
      }
      paint();
    });
    on(autoButton, 'click', () => {
      if (window.OBCDN?.auto) window.OBCDN.auto();
      else { try { localStorage.removeItem('obc-theme'); } catch {} autoTheme(); }
      paint();
    });
    const themeObserver = new MutationObserver(paint);
    themeObserver.observe(document.documentElement, {attributes:true, attributeFilter:['class']});
    paint();
    const sticky = root.querySelector('[data-sticky]');
    const primary = root.querySelector('[data-primary-cta]');
    const footer = document.querySelector('footer, [role="contentinfo"], .shopify-section-group-footer-group');
    const footerTarget = footer || root.querySelector('.obcv2__range') || root.querySelector('.obcv2__tabs');
    let frame = 0;
    let stickyObserver = null;
    let usingStickyFallback = false;
    const updateSticky = () => {
      frame = 0;
      if (!primary || !sticky) return;
      const primaryPassed = primary.getBoundingClientRect().bottom < 0;
      const footerVisible = footerTarget && footerTarget.getBoundingClientRect().top < window.innerHeight;
      sticky.hidden = !(primaryPassed && !footerVisible);
    };
    const scheduleSticky = () => {
      if (!frame) frame = requestAnimationFrame(updateSticky);
    };
    if (primary && sticky && 'IntersectionObserver' in window) {
      let primaryVisible = true;
      let primaryBelowViewport = true;
      let footerVisible = false;
      const renderSticky = () => {
        sticky.hidden = primaryVisible || primaryBelowViewport || footerVisible;
      };
      stickyObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.target === primary) {
            primaryVisible = entry.isIntersecting;
            primaryBelowViewport = entry.boundingClientRect.top >= window.innerHeight;
          }
          if (entry.target === footerTarget) footerVisible = entry.isIntersecting;
        });
        renderSticky();
      }, { threshold: 0 });
      stickyObserver.observe(primary);
      if (footerTarget) stickyObserver.observe(footerTarget);
    } else {
      usingStickyFallback = true;
      on(window, 'scroll', scheduleSticky);
      on(window, 'resize', scheduleSticky);
      updateSticky();
    }
    const cleanup = () => {
      if (lb?.open) lb.close();
      restore();
      controller.abort();
      if (frame) cancelAnimationFrame(frame);
      if (!usingStickyFallback) stickyObserver?.disconnect();
      themeObserver.disconnect();
      instances.delete(root);
    };
    instances.set(root, cleanup);
  };
  const initAll = () => {
    instances.forEach((cleanup, root) => { if (!root.isConnected) cleanup(); });
    document.querySelectorAll('[data-obc-product]').forEach(init);
  };
  window[namespace] = {initAll};
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((cleanup, root) => { if (event.target.contains(root)) cleanup(); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, {once:true}); else initAll();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pesto-marquee"] && !Shopify.designMode) return;
  try {
    

    if (!customElements.get('scrolling-text')) {
        customElements.define('scrolling-text', class ScrollingText extends HTMLElement {
        constructor() {
            super();
        }
    
        connectedCallback() {
            this.observer = new IntersectionObserver((entries, observer) => {
            if(entries[0].isIntersecting) {
                this.runAnimation();
                this.observer.disconnect();
            }
            });
        
            this.observer.observe(this);
        }
    
        disconnectedCallback() {
            if(this.observer) {
            this.observer.disconnect();
            }
        }
    
        runAnimation() {
            setTimeout(() => {
            this.classList.add('enable-animation');
            }, 500);
        }
    });
  }



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
            const checkNoSlider= this.querySelector('items-carousel')
            if( checkNoSlider  != null ){
              checkNoSlider.flickity.resize()
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
